//
//
//
//
//
//
//
//
//


export default {
	name: 'FormFile',

	props: {
		label: {
			type: String
		},

		required: {
			type: Boolean,
			default: false
		},

		invalid: {
			type: [Boolean, Array],
			default: false
		},

		name: {
			type: String,
			default: ''
		},

		clear: {
			type: Boolean,
			default: false
		}
	},

	data: function data() {
		return {
			fileNames: []
		};
	},


	methods: {
		clearFile: function clearFile() {
			this.fileNames = [];
			this.$emit('change', null);
		},
		onChange: function onChange() {
			var _this = this;

			var files = this.$refs.file.files;

			this.fileNames = [];

			Array.prototype.forEach.call(files, function (file) {
				_this.fileNames.push(file.name);
			});

			this.$emit('change', files);
		}
	},

	watch: {
		clear: function clear(val) {
			if (val) this.clearFile();
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/FormFile.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/FormFile.vue
// module chunks = 0 1 2